module.exports = __webpack_public_path__ + "img/footIconSecond.07036e2a.png";